import crudHandlers from './_crud'

const initialState = {
    entities: {},
    is_fetching: false,
    active: undefined,
    customUnits: [],
    isLoadingCustomUnits: false,
}

export default (state = initialState, action) => {
    const { type } = action
    switch (type) {
        case 'GETINSURANCELOGS': {
			var { response, payload } = action

			return {
				...state,
				insurance_logs: response,
			}
		}
        default:
            state = crudHandlers(state, action, 'insurance_log')

            return state
    }
}
